<template>
	<div :class="`relative ${full ? 'grow' : ''} flex items-center`">
		<div class="absolute px-2 py-1 flex items-center">
			<i :class="iconClass"/>
		</div>
		<GenericInput type="date" :min="min" :max="max" :value="date" class="!pl-7 !pr-2 !py-1" :full="full" @update:value="updateValue"/>
	</div>
</template>
<script setup lang="ts">
import {defineProps, defineEmits, ref, type Ref} from 'vue'
import GenericInput from '@/Components/Inputs/GenericInput.vue'
import dayjs from 'dayjs'

const props = defineProps<{
	modelValue:string,
	iconClass:string,
	min?:string,
	max?:string,
	full?:boolean,
}>()

const emit = defineEmits([
	'update:modelValue',
])

const date: Ref<string> = ref((props.modelValue ? dayjs(props.modelValue) : dayjs()).format('YYYY-MM-DD'))

function updateValue(newValue: string): void{
	emit('update:modelValue', newValue)
}
</script>
